window.DocLinkInList = {
	
	prepareLinkForm: function(formId){
		
		var action		= $('#'+formId).find('input[name=action]').val();
		var actionFile	= $('#'+formId).find('input[name=context]').val() == 'purchases' ? 'purchases_purchases' : 'doc';
		var options = {
			beforeSend	: function(){
				MyFacture.startWait();
			},
			success:function(data){
				var formIsOk = MyForm.processJson(data, formId);
				MyFacture.stopWait();
				
				if(!formIsOk && data.form.msg !== ''){
					MyWindow.alert(data.form.msg, {type : 'error'});
				}
			}, 
			dataType:"json"
		};


		MyForm.prepare(formId, actionFile, options);
		
		
		$('.link_amount').on('keyup', function(){
			
			var numformat = NumberFormat.loadFromInputs('num_');
			var totalLinked = Big(0);
			
			$('.linked:not(.template)').each(function () {
				var linkedAmount = NumberFormat.formatToFloat($(this).find('.link_amount').val(), numformat);
				totalLinked = totalLinked.plus(linkedAmount);
			});
			
			$('.totalValue').html(NumberFormat.formatToDisplay(totalLinked.toString(), numformat, true)+" "+numformat.currency);
		});
		
		if($('.linkedContainer li:not(.template)').length > 0){
			$("#submitLink").show();
			$(".placeholder").hide();
		}else{
			$(".placeholder").show();
			$("#submitLink").hide();
		}
		
	},
	
	unbindFilters : function(){
		$('a[id*=_filter_currency]').attr('aria-disabled', 'true');
		$('input[name*=_filter_thirds]').closest('.filter_underlabel').find('*').off('click').off('change').off('keyup').off('focus');
		$('input[name*=_filter_thirds]').closest('.filter_underlabel').find('input').off('focus');
		$('input[name*=_filter_thirds]').closest('.filter_underlabel').find('input').on('focus', function(){
			$(this).trigger('blur');
		});
		
		$('input[name*=_filter_thirds]').closest('.filter_underlabel').off('input').on('focus', function(){
			$(this).trigger('blur');
		});
		
		
		$('input[type=checkbox][name*=filter_step]').closest('.filter_underlabel').find('label').attr('aria-disabled', 'true').addClass('ui-state-disabled');
		$('input[type=checkbox][name*=filter_step]').closest('.filter_underlabel').find('label').on('click', function(){
			return false;
		});
		
		$('input[type=checkbox][name*=filter_step]').closest('.filter_underlabel').find('input').on('click', function(){
			return false;
		});

	},
		
	init : function(){
	
		DocLinkInList.prepareLinkForm("docLinkinlistForm");
		var $linkForm = $('#docLinkinlistForm');
		
		var numformat = NumberFormat.loadFromInputs('num_');

		setTimeout(function(){
			DocLinkInList.unbindFilters();
		}, 1000);
		
		
		var action	= $linkForm.find('input[name=action]').val();
		var context	= $linkForm.find('input[name=context]').val();
		
		$('#groupedActions').off('click');
		$('.listingFilterFormated').hide();
		
		switch (action){
			case 'linkedToDoc':
			case 'linkToDoc':
				
				$('.export').hide();
				
				setTimeout(function(){
					$('.listing tbody tr input:checkbox').off('click');
				}, 1000);
				
				$(document).off('change', '.listing tbody tr input:checkbox').on('change', '.listing tbody tr input:checkbox', function(e){
					
					e.stopPropagation();
					e.preventDefault();

					var actionCheck	= $(this);
					var checkerID	= $(this).attr('id');
					
					if($(this).is(':checked')){
						var amountMaxLinkable = parseFloat($("#link_dueAmount").val(), 10);

						var totalLinked = Big(0);
						
						$('.linked:not(.template)').each(function(){
							var linkedAmount = NumberFormat.formatToFloat($(this).find('.link_amount').val(), numformat);
							totalLinked = totalLinked.plus(linkedAmount);
						});

						var amountRemainingToLink = Big(amountMaxLinkable).minus(totalLinked);
						
						actionCheck.prop('checked', true);

						var $linked		= $('.linked.template', $linkForm).clone();
						var relatedID	= actionCheck.attr('id');
						var dueAmount	= actionCheck.data('due');
						var relatedType	= actionCheck.data('relatedtype');
						var toSettle	= dueAmount;

						$linked.removeClass('template');
						
						$linked.attr('id', 'linked-'+relatedID);

						$linked.find('.link_docid').attr('name', 'link_related['+relatedID+'][docid]')
							.attr('id', 'link_related_'+relatedID+'_docid')
							.val(relatedID);
									
						$linked.find('.link_doctype').attr('name', 'link_related['+relatedID+'][doctype]')
							.attr('id', 'link_related_'+relatedID+'_doctype')
							.val(relatedType);
					
						
						$linked.find('.link_docMaxAmount').attr('name', 'link_related['+relatedID+'][docMaxAmount]')
							.attr('id', 'link_related_'+relatedID+'_docMaxAmount')
							.val(dueAmount);
					
						
						if(dueAmount > parseFloat(amountRemainingToLink.toString(), 10)){
							var toSettle = amountRemainingToLink;
						}else{
							var toSettle = dueAmount;
						}
						
						$linked.find('.link_amount').attr('name', 'link_related['+relatedID+'][amount]')
							.attr('id', 'link_related_'+relatedID+'_amount')
							.val(NumberFormat.formatToDisplay(toSettle, numformat, true));
					
						$linked.find('.link_amount').closest('.form-input').find('.input-addon').text(numformat.currency);
					
						
						$linked.find('.linked-ident').html(actionCheck.attr('link-ident'));
						$linked.find('.linked-totalAmount').html(NumberFormat.formatToDisplay(dueAmount, numformat, true)+" "+numformat.currency);
						$linked.find('.linked_due').html(NumberFormat.formatToDisplay(toSettle, numformat, true)+" "+numformat.currency);
						
						$linked.appendTo('.linkedContainer').fadeIn('fast', function(){
							MyFacture.customForm('#linked-'+relatedID, true);
							MyFacture.initEvent('#linked-'+relatedID);
						});
					}else{
						$('#linked-'+checkerID).remove();

					}
					
					if($('.linkedContainer li:not(.template)').length > 0){
						$("#submitLink").show();
						$(".info.total").show();
						$(".placeholder").hide();
					}else{
						$(".placeholder").show();
						$(".info.total").hide();
						$("#submitLink").hide();
					}
					
					var totalLinked = 0;
					$('.linked:not(.template)').each(function(){
						var linkedAmount = NumberFormat.formatToFloat($(this).find('.link_amount').val(), numformat);
						totalLinked = totalLinked + linkedAmount;
					});
					

					$('.totalValue').html(NumberFormat.formatToDisplay(totalLinked.toString(), numformat, true)+" "+numformat.currency);
					return false;
				});

                $('.listing tbody tr td').removeAttr('onclick');
				$(document).off('click', '.listing tbody tr td:not(.groupedActionCheckerContainer)').on('click', '.listing tbody tr td:not(.groupedActionCheckerContainer)', function(e){
					var checker = $(this).closest('tr').find('input:checkbox');
					checker.prop('checked', !checker.prop('checked'));
					checker.trigger('change');
				});
				
				
				
				$('.listing').off('Listing::update').on('Listing::update', function(){
					console.log("Do something");
				});

				break;
		}
	}


};